<template>
  <div v-if="telaUnica">
    <v-app>
      <router-view/>
    </v-app>
  </div>
  <div v-else>
    <hal-informativos :produto-id="150"></hal-informativos>
    <hal-notificacoes v-if="!telaUnica && !ocultarNotificacoesAtual" ref="halMenuNotificacoes" align-items="left"></hal-notificacoes>
    <hal-menu-produtos v-if="!telaUnica" ref="halMenuProdutos"></hal-menu-produtos>
    <hal-banner-ambiente v-if="!telaUnica" ref="halBannerAmbiente" produto-id="150" />
    <modal-banner
        v-if="modalBanner && exibirBanner"
        v-model="modalBanner"
        :titulo="titulo"
        :link="link"
        @fecharModalBanner="fecharModalBanner"
    />
    <az-template-default>
      <router-view/>
      <template v-slot:bannerAside v-if="!menuLateralRecolhido && usuarioInterno">
        <div class="imagem-banner-lateral" v-if="exibirBanner">
          <v-img :src="require('@/assets/banner-assinegov.png')" @click="abrirModalBanner"/>
        </div>
      </template>
      <template v-slot:bannerAside v-else>
        <div class="imagem-banner-lateral" v-if="exibirBanner">
          <v-img :src="require('@/assets/banner-fornecedor.png')" @click="redirecionarBannerFornecedor"/>
        </div>
      </template>
      <WeniChat :url="linkChat"></WeniChat>
    </az-template-default>
  </div>
</template>
<script>
import axios from 'axios'
import {mapMutations, mapState} from 'vuex'
import {mutationTypes, actionTypes} from '@/commons/constants'
import ModalBanner from '@/commons/components/ModalBanner'
import WeniChat from "@/commons/components/chat/WeniChat";

export default {
  components: {WeniChat, ModalBanner},
  data(){
    return{
      modalBanner: false,
      titulo: '',
      link: ''
    }
  },
  computed: {
    ...mapState(['file', 'loki', 'parametros', 'novidadeDisponivel']),
    exibirBanner(){
      return this.parametros.propriedadesLicitacao.exibirBanner !== false
    },
    linkChat(){
      return this.parametros.propriedadesLicitacao.linkChat
    },
    telaUnica() {
      return !!(this.$route && this.$route.meta && this.$route.meta.independente)
    },
    menuLateralRecolhido(){
      return this.loki.asideClosed
    },
    usuarioInterno(){
      return this.loki.user.type === 'INTERNO'
    },
    ocultarNotificacoesAtual() {
      try { return !!(this.$route && this.$route.meta && this.$route.meta.ocultarNotificacoes) } catch (e) { return false }
    }
  },
  created() {
    this.setSystemColors()
    this.setApiArquivos(this.file)
    this.carregarTimezone()
    this.recarregarPerfis()
    this.configRequestsHalWebComponents()
    const originalAppendChild = Element.prototype.appendChild

    Element.prototype.appendChild = function(child) {
      if (
          window.location.pathname.includes('selecionar-dominio') &&
          ['HAL-NOTIFICACOES', 'HAL-MENU-PRODUTOS', 'HAL-BANNER-AMBIENTE'].includes(child.tagName)
      ) {
        return child
      }
      return originalAppendChild.call(this, child)
    }
  },
  mounted(){
    if (!this.telaUnica) {
      this.inserirNotificacaoNovidades()
      this.incluirHalMenuProdutoNoHeader()
      if (!this.ocultarNotificacoesAtual) {
        this.incluirHalMenuNotificacaoNoHeader()
      }
      this.incluirHalBannerAmbiente()
    } else {
      this.removerHalGlobal()
      setTimeout(() => this.removerHalGlobal(), 100)
    }
  },
  watch: {
    telaUnica(novoValor) {
      if (!novoValor) {
        this.$nextTick(() => {
          this.safeIncluirHal()
        })
      } else {
        this.removerHalGlobal()
        setTimeout(() => this.removerHalGlobal(), 100)
      }
    },
    $route() {
      if (!this.telaUnica) {
        this.$nextTick(() => {
          this.incluirHalMenuProdutoNoHeader()
          if (!this.ocultarNotificacoesAtual) {
            this.incluirHalMenuNotificacaoNoHeader()
          }
          this.incluirHalBannerAmbiente()
        })
      }
    }
  },
  methods: {
    safeIncluirHal(){
      const tentar = () => {
        const produtos = this.$refs.halMenuProdutos
        const notificacoes = this.$refs.halMenuNotificacoes
        const banner = this.$refs.halBannerAmbiente
        if (produtos) { this.incluirHalMenuProdutoNoHeader() }
        if (notificacoes && !this.ocultarNotificacoesAtual) { this.incluirHalMenuNotificacaoNoHeader() }
        if (banner) { this.incluirHalBannerAmbiente() }
      }
      try { tentar() } catch (e) {}
      try { setTimeout(tentar, 100) } catch (e) {}
    },
    inserirNotificacaoNovidades(){
      if(!this.novidadeDisponivel || !this.usuarioInterno){return}
      const elementos = [...document.querySelectorAll('aside .menu .v-list__group__items--no-action .v-list__tile')]
      const elementoNovidades = elementos.find(el => el.innerText.includes('Novidades'))
      if(!elementoNovidades){
        return;
      }
      elementoNovidades.classList.add('notificar');
      const spanNotificacao = document.createElement("span")
      spanNotificacao.classList.add('circulo-notificacao')
      const tituloSubmenuNotificar = document.querySelector('aside .menu .v-list__group__items--no-action .v-list__tile.notificar .v-list__tile__title')
      tituloSubmenuNotificar.appendChild(spanNotificacao)
    },
    setSystemColors(){
      const primary = this.parametros.propriedadesLicitacao.tema.primaryColor
      const secondary = this.parametros.propriedadesLicitacao.tema.secondaryColor
      if(primary) {
        this.$vuetify.theme.primary = primary
      }
      if(secondary){
        this.$vuetify.theme.secondary = secondary
      }
    },
    abrirModalBanner(){
      if(this.usuarioInterno){
        this.titulo = 'AssineGov - Assinatura eletrônica para seu órgão público'
        this.link = 'https://www.youtube.com/embed/KF4Ia8WMqZc'
      }
      this.modalBanner = true
    },
    fecharModalBanner(){
      this.modalBanner = false
    },
    redirecionarBannerFornecedor(){
      window.open('https://comprasbr.com.br/cotacoes-br/?utm_source=area_fornecedor&utm_medium=banner&utm_id=cotacoes_br', '_blank');
    },
    carregarTimezone() {
      this.setTimezone(this.parametros.propriedadesLicitacao.timezone)
    },
    configRequestsHalWebComponents() {
      const halGlobal = window.hal || {}
      window.hal = {
        ...halGlobal,
        http: {
          get: async ({ url, config }) => axios.get(url, config),
          post: async ({ url, data, body, config }) => axios.post(url, (data !== undefined ? data : body), config),
          put: async ({ url, data, body, config }) => axios.put(url, (data !== undefined ? data : body), config),
          delete: async ({ url, config }) => axios.delete(url, config),
        },
      }
    },
    incluirHalMenuProdutoNoHeader() {
      const halMenuProdutos = this.$refs.halMenuProdutos

      const tentarInserir = () => {
        const toolbar = document.querySelector('.v-toolbar__content')
          || document.querySelector('nav.v-toolbar .v-toolbar__content')
          || document.querySelector('header .v-toolbar__content')
        const avatar = document.querySelector('.az-avatar') || (toolbar ? toolbar.lastElementChild : null)

        if (toolbar && avatar && halMenuProdutos) {
          try {
            // Evitar duplicação: apenas insere se não estiver no lugar esperado
            if (halMenuProdutos.parentElement !== toolbar || halMenuProdutos.nextElementSibling !== avatar) {
              toolbar.insertBefore(halMenuProdutos, avatar)
            }
            return true
          } catch (e) {}
        }
        return false
      }

      const iniciarTentativas = () => {
        let tentativas = 0
        const maxTentativas = 20
        const intervalo = 150
        const timer = setInterval(() => {
          if (tentarInserir() || ++tentativas >= maxTentativas) {
            clearInterval(timer)
          }
        }, intervalo)
      }

      if (window.customElements && customElements.whenDefined) {
        try {
          customElements.whenDefined('hal-menu-produtos').then(() => iniciarTentativas())
        } catch (e) {
          this.$nextTick(() => iniciarTentativas())
        }
      } else {
        this.$nextTick(() => iniciarTentativas())
      }
    },
    removerHalGlobal() {
      const seletores = [
        'hal-notificacoes',
        'hal-menu-produtos',
        'hal-banner-ambiente'
      ]

      seletores.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          if (el && el.parentElement) {
            el.parentElement.removeChild(el)
          }
        })
      })
    },
    incluirHalMenuNotificacaoNoHeader() {
      const halMenuNotificacoes = this.$refs.halMenuNotificacoes
      const halMenuProdutos = this.$refs.halMenuProdutos

      const tentarInserir = () => {
        const toolbar = document.querySelector('.v-toolbar__content')
          || document.querySelector('nav.v-toolbar .v-toolbar__content')
          || document.querySelector('header .v-toolbar__content')

        const anchorPreferencial = (halMenuProdutos && halMenuProdutos.parentElement === toolbar)
          ? halMenuProdutos
          : (toolbar ? toolbar.querySelector('hal-menu-produtos') : null)

        const anchorFallback = document.querySelector('.az-avatar')
          || (toolbar ? toolbar.lastElementChild : null)

        const anchor = anchorPreferencial || anchorFallback

        if (toolbar && anchor && halMenuNotificacoes) {
          try {
            toolbar.insertBefore(halMenuNotificacoes, anchor)
            return true
          } catch (e) {
          }
        }
        return false
      }

      let tentativas = 0
      const maxTentativas = 20
      const intervalo = 150
      const timer = setInterval(() => {
        if (tentarInserir() || ++tentativas >= maxTentativas) {
          clearInterval(timer)
        }
      }, intervalo)
    },
    ...mapMutations([mutationTypes.LOKI.SET_TIMEZONE]),
    recarregarPerfis() {
      window.addEventListener('focus', async () => {
        if (this.$store.state.loki.user.domainId) {
          this.desabilitarLoadingGlobal()
          await this.$store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, {
            dominioClienteId: this.$store.state.loki.user.domainId,
            dominioTipo: this.$store.state.loki.user.domainType
          })
        }
      })
    },
    /**
     * Ajuste defensivo para inserir o web component hal-banner-ambiente e aplicar espaçamentos:
     * - Garante a existência dos elementos antes de usá-los (null-guards).
     * - Usa try/catch ao inserir no DOM para evitar quebra caso já esteja inserido ou o pai não exista.
     * - Substitui o setTimeout por pequenas tentativas (polling) após customElements.whenDefined,
     *   aguardando o shadowRoot e o nó interno existirem antes de ler offsetHeight.
     * - Se não for possível obter as referências após algumas tentativas, finaliza silenciosamente.
     */
    incluirHalBannerAmbiente(){
      const halBannerAmbiente = this.$refs.halBannerAmbiente
      const applicationWrap = document.querySelector('.application--wrap')
      const azToolbar = document.querySelector('nav.v-toolbar')
      const azAside = document.querySelector('aside.az-aside')
      const mainContent = document.querySelector('main.v-content')

      if (halBannerAmbiente && applicationWrap && azToolbar) {
        try {
          applicationWrap.insertBefore(halBannerAmbiente, azToolbar)
        } catch (e) {
        }
      }

      const aplicarPadding = () => {
        if (!halBannerAmbiente || !azToolbar || !azAside || !mainContent) {
          return
        }
        const shadow = halBannerAmbiente.shadowRoot
        if (!shadow) {
          return
        }
        const div = shadow.querySelector('div')
        if (!div) {
          return
        }
        const altura = div.offsetHeight || 0
        const alturaTopo = (azToolbar.offsetHeight || 0) + altura

        const asideInner = azAside.querySelector('.az-aside')
        if (asideInner) {
          asideInner.style['padding-top'] = `${altura}px`
        }
        azToolbar.style['padding-top'] = `${altura}px`
        mainContent.style['padding-top'] = `${alturaTopo}px`
      }

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('hal-banner-ambiente').then(() => {
          let tentativas = 0
          const maxTentativas = 20
          const intervalo = 100
          const timer = setInterval(() => {
            aplicarPadding()
            tentativas++
            const ok = halBannerAmbiente && halBannerAmbiente.shadowRoot && halBannerAmbiente.shadowRoot.querySelector('div')
            if ((ok && halBannerAmbiente.shadowRoot.querySelector('div').offsetHeight >= 0) || tentativas >= maxTentativas) {
              clearInterval(timer)
            }
          }, intervalo)
        })
      } else {
        this.$nextTick(() => aplicarPadding())
      }
    }
  }
}
</script>

<style lang="stylus">

.imagem-assine-gov
  height 55%
  overflow hidden

.imagem-assine-gov:hover
  cursor pointer

.v-toolbar__content
  .btn-close
    margin-right 10px !important

.az-container
  margin: 20px 20px 60px 20px !important

.az-form-content
  .container
    background-color white !important

.btn-advanced-search
  color white !important

.icon-search
  height 32px !important
  width 32px !important

.li-tabela
  tbody tr
    border-bottom: 1px solid #e9e9e9 !important

    td
      height: 40px
      color: #777777
      font-size: 13px
      font-weight: normal
      padding: 0 20px !important

    .table-actions a i
      font-size: 20px
      color: #888

    .table-actions a
      margin-left: 10px

.action-primary-button
  padding 10px 15px
  border 1px solid #7aa329
  background-color #7aa329
  color white
  margin-left 10px
  border-radius 2px

  &:hover
    background-color lighten(#7aa329, 10%)
    border 1px solid lighten(#7aa329, 10%)

.action-secundary-button
  padding 10px 15px
  margin-left 10px
  color #777777

  &:hover
    color darkred

.btn-disabled
  pointer-events visible !important
  cursor not-allowed

.action-primary-button-disabled
  padding 10px 15px
  border 1px solid #E0E0E0
  background-color #E0E0E0
  color #A8A8A8
  margin-left 10px
  border-radius 2px

.anexo-button
  padding 5px 10px
  border 1px solid #979797
  background-color #979797
  color white
  border-radius 2px

.max-25
  max-width 25vw

.max-13
  max-width 13vw

.text-truncate-multiline
  word-break break-word

aside .active-menu::after
  content none !important

aside .menu .v-list__tile__action
  padding-right 5px

aside .menu .v-list__group__header__append-icon
  padding-right 8px
  padding-left  0

aside .menu .v-list__group__items--no-action .v-list__tile.notificar .v-list__tile__title .circulo-notificacao
  height: 8px;
  width: 8px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  margin-bottom 8px
  margin-left 4px
  margin-right 4px

body:hover aside .menu .v-list__group__items--no-action .v-list__tile.notificar .v-list__tile__title .circulo-notificacao
    animation: rainbow-bg 5s linear;
    animation-iteration-count: infinite;

@keyframes rainbow-bg{
  100%,0%{
    background-color: rgb(255,0,0);
    transform: scale(1);
  }
  10%{
    background-color: rgb(255,127,0);
    transform: scale(1.2);
  }
  20%{
    background-color: rgb(255,255,0);
    transform: scale(1);
  }
  30%{
    background-color: rgb(127,255,0);
    transform: scale(1.2)
  }
  40%{
    background-color: rgb(0,255,0);
    transform: scale(1)
  }
  50%{
    background-color: rgb(0,255,127);
    transform: scale(1.2)
  }
  60%{
    background-color: rgb(0,255,255);
    transform: scale(1)
  }
  70%{
    background-color: rgb(127,0,255);
    transform: scale(1.2)
  }
  80%{
    background-color: rgb(255,0,255);
    transform: scale(1)
  }
  90%{
    background-color: rgb(255,0,127);
    transform: scale(1.2)
  }
}

.v-snack__content
  white-space normal !important
  word-break break-word
  overflow-wrap break-word
  line-height 1.4
  display block
  padding 0 !important

.v-snack__wrapper
  height auto !important
  padding 12px 12px !important
  min-height unset !important

#azFileProgress
  margin-right 50px

</style>
